import ListItemIcon from "@mui/material/ListItemIcon";
import { styled } from "@mui/material/styles";

const StyledListItemIcon = styled(ListItemIcon)({
  minWidth: "2rem",
});

export default StyledListItemIcon;
